
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-30">
      <nav className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r from-yellow-500 to-yellow-300 rounded transform rotate-12"></div>
            <h1 className="text-2xl font-bold text-yellow-600">GoldenTicketLucky</h1>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <a href="/" className="text-gray-700 hover:text-yellow-600 transition-colors">Home</a>
            <a href="/play" className="text-gray-700 hover:text-yellow-600 transition-colors">Play</a>
            <a href="/about" className="text-gray-700 hover:text-yellow-600 transition-colors">About</a>
            <a href="/results" className="text-gray-700 hover:text-yellow-600 transition-colors">Results</a>
            
            <a href="/contact" className="text-gray-700 hover:text-yellow-600 transition-colors">Contact</a>
            <div className="relative group">
              <button className="text-gray-700 hover:text-yellow-600 transition-colors">Legal</button>
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <a href="/terms" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50">Terms</a>
                <a href="/privacy" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50">Privacy</a>
                <a href="/cookies" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50">Cookies</a>
                <a href="/accessibility" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50">Accessibility</a>
                <a href="/notices" className="block px-4 py-2 text-gray-700 hover:bg-yellow-50">Notices</a>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-2">
            <a href="/" className="block py-2 text-gray-700 hover:text-yellow-600">Home</a>
            <a href="/play" className="block py-2 text-gray-700 hover:text-yellow-600">Play</a>
            <a href="/about" className="block py-2 text-gray-700 hover:text-yellow-600">About</a>
            <a href="/results" className="block py-2 text-gray-700 hover:text-yellow-600">Results</a>
            <a href="/updates" className="block py-2 text-gray-700 hover:text-yellow-600">Updates</a>
            <a href="/contact" className="block py-2 text-gray-700 hover:text-yellow-600">Contact</a>
            <a href="/terms" className="block py-2 text-gray-700 hover:text-yellow-600">Terms</a>
            <a href="/privacy" className="block py-2 text-gray-700 hover:text-yellow-600">Privacy</a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
